// Email addresses for fodindin.net - to be forwarded via ImprovMX -> Gmail
export const EMAILS = {
  contact: "contact@fodindin.net",
  support: "support@fodindin.net",
  partenariats: "partenariats@fodindin.net",
  marketing: "marketing@fodindin.net",
  admin: "admin@fodindin.net",
};

export const CONTACT_REASONS = [
  { key: "contact", label: "Question generale", email: EMAILS.contact, desc: "Pour toute question sur le service Fodindin." },
  { key: "support", label: "Support technique", email: EMAILS.support, desc: "Un bug, une annonce qui ne s'affiche pas, un probleme de paiement." },
  { key: "partenariats", label: "Partenariats", email: EMAILS.partenariats, desc: "Vous etes hotel, agence ou marque et souhaitez collaborer." },
  { key: "marketing", label: "Marketing & promotions", email: EMAILS.marketing, desc: "Campagnes, mises en avant et opportunites de visibilite." },
];
